module.exports = __webpack_public_path__ + "static/media/Finesse.551f78a8.md";